const translations = {
  cancel: 'Cancelar',
  save: 'Salvar',
  next: 'Próximo',
  back: 'Voltar',
  undo: 'Desfazer',
  search: 'Busca',
  user: 'Usuário',
  place: 'Local',
  images: 'Imagens',
  files: 'Arquivos',
  notApplicable: 'N/A',
  removed: 'Removido',
  disabled: 'Desativado',
  enabled: 'Ativados',
  addNewOption: 'Add nova opção',
  selectEmoji: 'Selecionar emoji',
  optional: 'opcional',
  'emoji.smileysPeople': 'Smileys & Pessoas',
  'emoji.animalsNature': 'Animais & Natureza',
  'emoji.foodDrink': 'Comida & Bebidas',
  'emoji.travelPlaces': 'Viagens & Lugares',
  'emoji.activities': 'Atividades',
  'emoji.objects': 'Objetos',
  'emoji.symbols': 'Símbolos',
  complement: 'Complemento',
  complementOptional: 'Complemento (opcional)',
  hour: 'Hora',
  minute: 'Min.',
  errorLoadingGoogleMaps: 'Erro ao carregar google maps',
  'pdf.autoPageBreak': 'Auto ajuste de quebra de páginas',
  'pdf.baseFontSize': 'Tamanho base das fontes',
  'pdf.enableColors': 'Habilitar cores',
  'pdf.showImages': 'Mostrar imagens',
  'pdf.showSignature': 'Mostrar assinatura',
  'pdf.imageHeight': 'Altura das imagens',
  'pdf.itemsPerLine': 'Imagens e arquivos por linha',
  'pdf.options.realSize': 'Dimensão real',
  'pdf.options.size.verySmall': 'Muito pequeno',
  'pdf.options.size.small': 'Pequeno',
  'pdf.options.size.standard': 'Padrão',
  'pdf.options.size.medium': 'Médio',
  'pdf.options.size.large': 'Grande',
  'pdf.options.size.veryLarge': 'Muito grande',
  'pdf.options.size.giant': 'Gigante',
  'pdf.options.sizeWithPx': '{{size}} ({{px}}px)',
  'pdf.options.sizeWithNumber': '{{size}} ({{value}})',
  'pdf.options.perLine': '{{count}} por linha',
  'pdf.download': 'Baixar {{extension}}',
  'pdf.imagesCount': '{{count}} imagem',
  'pdf.imagesCount_plural': '{{count}} imagens',
  'pdf.filesCount': '{{count}} arquivo',
  'pdf.filesCount_plural': '{{count}} arquivos',
  'pdf.itemCount': '{{count}} item',
  'pdf.itemCount_plural': '{{count}} itens',
  'pdf.notes': 'Anotações',
  'pdf.photos': 'Fotos',
  'pdf.active': 'Ativo',
  'pdf.inactive': 'Inativo',
  'pdf.stock.item': 'Item',
  'pdf.stock.amount': 'Quantidade',
  'pdf.stock.operation': 'Operação',
  'pdf.stock.user': 'Usuário',
  'pdf.stock.place': 'Local',
  'filter.enabledDisabled': 'Ativado/Desativado',
  'filter.enabled': 'Ativados',
  'filter.disabled': 'Desativados',
  'filter.removed': 'Removidos',
  'messages.mobileAccuracy': 'Para uma maior precisão, responda pelo aplicativo.',
  clearAndInsertNewSignature: 'Limpar e inserir nova assinatura',
  clear: 'Limpar',
  insertSignature: 'Inserir assinatura',
  document: 'Documento',
  includeSignatureInRectangle: 'Inclua sua assinatura dentro do retangulo',
  nameRequired: 'Nome (obrigatório)',
  addSignature: 'Adicionar assinatura',
  signaturePrefilledFromProfile: 'Assinatura preenchida com os dados do seu perfil. Você pode alterar se desejar.',
  updateLocation: 'Atualizar Localização',
  saveLocation: 'Salvar Localização',
  latitude: 'Latitude',
  longitude: 'Longitude',
  permissionDeniedInBrowser: 'Permissão negada no navegador',
  'processesMessage.backToPreviousVersion': 'Voltar para a versão anterior',
  processesMessagebackToPreviousVersion: 'Voltar para a versão anterior',
  'processesMessage.activateNewVersion': 'Ativar a nova versão',
  'processesMessage.newFeatureActivated': '**Nova funcionalidade ativada!**',
  'processesMessage.discoverNewFeature': '**Conheça a nova funcionalidade!**',
  'processesMessage.enjoyNewFeature': 'Aproveite a nova funcionalidade para gerenciar atividades por processo.',
  'processesMessage.viewAndManageByProcess': 'Visualize e gerencie atividades por processo.',
  generalRegistrations: 'Cadastros gerais',
  pendingTypes: 'Tipos de pendencias',
  approvalReasons: 'Motivos de aprovação',
  disapprovalReasons: 'Motivos de reprovação',
  unproductiveReasons: 'Motivos de improdutividade',
  cancellationReasons: 'Motivos de cancelamento',
  pauseReasons: 'Motivos de pausa',
  closingReasons: 'Motivos de encerramento',
  userGroups: 'Grupos de usuários',
  assetTypes: 'Tipos de ativos',
  checklistCategories: 'Categorias dos questionários',
  levelsOf: 'Niveis de {{name}}'
}

export default translations
